import { render, staticRenderFns } from "./UsersPrivilegeServiceResponsibleBonuses.vue?vue&type=template&id=5ad00112&scoped=true&"
import script from "./UsersPrivilegeServiceResponsibleBonuses.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeServiceResponsibleBonuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad00112",
  null
  
)

export default component.exports